// Footer email signup: ask the support worker for this email's single-use
// welcome code and show it in place of the form, so every subscriber gets a
// code of their own (the popup does the same through its simple mode). When
// the worker can't be reached, the form submits to Shopify as it always did.
if (!window.avSignupCode) {
  window.avSignupCode = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.dataset.supportOrigin || form.dataset.avNative === '1') return;
    const email = form.querySelector('input[type="email"]')?.value.trim() ?? '';
    if (!email) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${form.dataset.supportOrigin}/spin`, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email, mode: 'simple' }) });
      if (!response.ok) throw new Error('signup');
      const prize = await response.json();
      if (!prize?.code) throw new Error('signup');
      // The worker could not subscribe them: let Shopify's own form do it quietly.
      if (prize.subscribed === false) fetch(form.action, { method: 'POST', body: new FormData(form) }).catch(() => {});
      const text = document.createElement('p');
      text.className = 'email-signup__message-text';
      const code = document.createElement('strong');
      code.textContent = prize.code;
      const note = prize.code.startsWith('WELCOME') ? 'Use it at checkout.' : "Use it at checkout. It's yours alone and good for 14 days.";
      text.append(`You're in. Your code for ${prize.label}: `, code, `. ${note}`);
      const message = document.createElement('div');
      message.className = 'email-signup__message';
      message.setAttribute('role', 'status');
      message.append(text);
      form.replaceChildren(message);
    } catch {
      form.dataset.avNative = '1';
      if (button) button.disabled = false;
      form.requestSubmit();
    }
  });
}
